import styled, { css } from "styled-components";
import { Control, FieldValues, Path, useController } from "react-hook-form";

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + div {
      background-color: ${({ theme }) => theme.colors.purple};
      &:before {
        transform: translateX(15px);
      }
    }
  }
`;

export const SwitchSlider = styled.div<{ $disabled: boolean }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.lightGray};
  transition: ease-out 0.2s;
  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
    `}
  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    border-radius: 50%;
    left: 2px;
    bottom: 2px;
    background-color: ${({ theme }) => theme.colors.white};
    transition: ease-out 0.2s;
  }
`;

interface Props<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  className?: string;
  disabled?: boolean;
}

const Switch = <T extends FieldValues>({
  name,
  control,
  className,
  disabled = false,
}: Props<T>) => {
  const {
    field: { onChange, value },
  } = useController({ name, control });

  return (
    <SwitchLabel className={className}>
      <input
        type="checkbox"
        disabled={disabled}
        checked={value}
        onChange={onChange}
      />
      <SwitchSlider $disabled={disabled} />
    </SwitchLabel>
  );
};

export default Switch;
